/**
 * Turns the app's closing lines into badges.
 *
 * The personalisation app renders them as one block of rich text with <br>
 * breaks - a paragraph of separate claims, which reads as a wall and gives no
 * weight to any single one. Each line is a self-contained fact, so each gets
 * its own chip.
 *
 * It only touches a block that looks like that one: display-only, several
 * short lines, no form field. Anything else is left exactly as written.
 */
(() => {
  const CONTAINER = '.product__info-container';
  const MIN_LINES = 2;
  const MAX_LINE = 90;

  /** Split a rich-text node into its visual lines, keeping inline markup. */
  const linesOf = (host) => {
    const out = [];
    host.querySelectorAll('p, div').forEach((para) => {
      if (para.querySelector('p, div')) return; // Only leaf blocks.
      let buffer = document.createElement('span');
      const flush = () => {
        if (buffer.textContent.trim()) out.push(buffer);
        buffer = document.createElement('span');
      };
      para.childNodes.forEach((node) => {
        if (node.nodeName === 'BR') flush();
        else buffer.append(node.cloneNode(true));
      });
      flush();
    });
    return out;
  };

  const build = (host) => {
    if (host.dataset.pitchBadges === 'true') return;
    if (host.querySelector('input, textarea, select, label, img, a')) return;

    const lines = linesOf(host).filter((l) => {
      const text = l.textContent.trim();
      return text.length > 2 && text.length <= MAX_LINE;
    });
    if (lines.length < MIN_LINES) return;

    const list = document.createElement('ul');
    list.className = 'pitch-badges list-unstyled';
    list.setAttribute('role', 'list');

    lines.forEach((line) => {
      const item = document.createElement('li');
      item.className = 'pitch-badge';
      item.append(line);
      list.append(item);
    });

    host.replaceChildren(list);
    host.dataset.pitchBadges = 'true';
  };

  const start = () => {
    document
      .querySelectorAll(CONTAINER + ' .gpo-element')
      .forEach((el) => {
        // The closing pitch is the long display-only block.
        if (el.textContent.trim().length < 60) return;
        build(el);
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.setTimeout(start, 1400), { once: true });
  } else {
    window.setTimeout(start, 1400);
  }
})();
